import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listSubmitterMasters,
  updateSubmitterMaster,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 計画提出者マスタ 更新 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 */
export function useUpdateSubmitterMaster(): InvalidatingMutationResultFor<
  typeof updateSubmitterMaster
> {
  return useInvalidatingMutation(updateSubmitterMaster, [
    createConnectQueryKey({
      schema: listSubmitterMasters,
      cardinality: 'finite',
    }),
  ])
}
